// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27><path d=%27M4 6l4 4 4-4%27 stroke=%27%23999%27 stroke-width=%272%27 fill=%27none%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll_lock {
    overflow: hidden;
}

.content {
    /* min-height:auto;  */
    /* margin-top:4.5rem;  */
    /* padding: 3.5rem 6% 1rem;  */
    /* border-radius:1rem;  */
}

.content:before {
    display: none;
}

.content .inner-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.content .tab-wrap {
    position: relative;
    width: 100%;
    max-width: 33.75rem;
    padding-top: .75rem;
    border-bottom: .0625rem solid #d1d5d9;
}

.content .tab-wrap li {
    display: inline-block;
    position: relative;
}

.content .tab-wrap li:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -.0625rem;
    height: .1875rem;
    background: #064e3b;
    border-top-left-radius: .1875rem;
    border-top-right-radius: .1875rem;
    opacity: 0;
}

.content .tab-wrap li a {
    display: block;
    padding: 0 1rem;
    font-size: .875rem;
    font-weight: bold;
    line-height: 3.25rem;
    cursor: pointer;
}

.content .tab-wrap li.current:before {
    opacity: 1;
}

.content .content-wrap {
    width: 100%;
    max-width: 33.75rem;
    margin: 0 auto;
    /* padding: .5rem 0 1rem;  */
}

.content .intro-y {
    /* display: flex; */
    flex-wrap: wrap;
    /* width:calc(100% + 1rem);  */
    /* height:100%; */
    /* margin-left: -.5rem; */
    background: #fff;
    padding: 10px;
    box-shadow: none;
    height: calc(-10rem + 100dvh);
    overflow: scroll;
}

/* payForm */
.content-wrap .payForm {
    display: none;
    margin: 0;
    padding: 0;
}

.content-wrap .payForm.active {
    display: block;
}

.payForm .form-label {
    margin-bottom: .375rem;
    font-size: .8125rem;
    font-weight: bold;
}

.payForm .input {
    width: 100%;
    /* margin: 0 .5rem 1rem; */
    margin: 0 0 0.75rem;
}

.payForm .input.w33 {
    width: calc(33.33% - 1rem);
}

.payForm .input.w50 {
    width: calc(50% - 1rem);
}

.payForm .input.w66 {
    width: calc(66.66% - 1rem);
}

.payForm .input .multiple {
    display: flex;
    align-items: center;
}

.payForm .input .multiple span {
    padding: 0 .375rem;
}

.payForm .mt-2,
.payForm .mt-3 {
    margin: 0;
}

.payForm .pos_aps_r {
    margin: .25rem 0 -1.25rem;
}

.payForm .payBt {
    width: 100%;
    margin: 1rem 0;
    text-align: center;
}

.payForm .payBt .btn {
    width: 100%;
    /* max-width: 12.5rem; */
}

/* cardInfo */
.content-wrap .cardInfo {
    display: none;
    width: 100%;
    max-width: 33.75rem;
    margin: 0;
    padding: 0;
    overflow-y: auto;
}

.content-wrap .cardInfo.active {
    display: block;
}

.cardInfo .tabulator {
    margin: 0;
    padding: 0;
}

.cardInfo .tabulator-header {
    border-width: 0;
}

.cardInfo .tabulator-headers {
    text-align: right;
}

.cardInfo .tabulator-headers>div:nth-child(1) {
    display: none;
}

.cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-content {
    margin-right: .5rem;
    text-align: right;
}

.cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-sorter {
    margin-right: -1.75rem;
}

.cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-title {
    font-size: .9375rem;
    font-weight: bold;
}

/* .cardInfo .tabulator-tableHolder {
    margin-top: .5rem;
    overflow: hidden;
} */

.tabulator .tabulator-tableHolder::-webkit-scrollbar {
    -webkit-appearance: none;
}

.tabulator .tabulator-tableHolder::-webkit-scrollbar:vertical {
    display: block;
    width: 1.125rem;
}

.tabulator .tabulator-tableHolder::-webkit-scrollbar:horizontal {
    display: block;
    height: 1.125rem;
}

.tabulator .tabulator-tableHolder::-webkit-scrollbar-thumb {
    height: 15%;
    border: .375rem solid transparent;
    background-clip: content-box;
    background-color: rgba(0, 0, 0, .25);
    border-radius: 1.125rem;
}

.tabulator .tabulator-tableHolder::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0);
}


.cardInfo .tabulator-tableHolder .tabulator-table {
    width: 100%;
    /* background: none; */
}

.cardInfo .tabulator-row,
.cardInfo .tabulator-row.tabulator-row-even {
    margin-bottom: 1.25rem;
    background: #fff;
    border-radius: .75rem;
    border-bottom-width: 0;
}

.cardInfo .tabulator-row .tabulator-cell {
    font-weight: bold;
}

.cardInfo .tabulator-row .tabulator-responsive-collapse table {
    width: 100%;
}

.cardInfo .tabulator-row .tabulator-responsive-collapse td {
    padding-top: .1875rem;
    padding-bottom: .1875rem;
    font-size: .8125rem;
}

.cardInfo .tabulator-row .tabulator-responsive-collapse td:nth-child(2) {
    font-weight: bold;
    text-align: right;
}

.cardInfo .tabulator-row .tabulator-responsive-collapse td strong {
    color: #a1a5a9;
}

.cardInfo .tabulator-footer .tabulator-paginator {
    justify-content: center;
    text-align: center;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.alert_modal .modal-footer {
    border-color: transparent;
}

.payment {
    height: 100%;
}

.payment .inner-wrap h2.title {
    padding-bottom: 1rem;
    /* margin: 0 0.5rem 0; */
    font-size: 1.0625rem;
    font-weight: bold;
    line-height: 3.25rem;
}

.payment .inner-wrap>ul.title li:nth-child(1) {
    width: 33rem;
}

.payment .inner-wrap>ul.title li:nth-child(2) {
    width: calc(100% - 33rem);
}

.payment .cardInfo .tabulator-footer .tabulator-page.active {
    background: #1a120b;
    color: #fff;
}

.payment .cardInfo .tabulator-footer .tabulator-page.active:hover {
    color: #fff;
    background: #3D3C42;
}

/* .payment .intro-y {
    height: calc(100vh - 12rem);
} */
@media (max-width: 766px) {
    .payment {
        height: auto;
    }
}

.table-report.table-report--tabulator .tabulator-header .tabulator-headers .tabulator-col:nth-child(3) .tabulator-col-content .tabulator-col-title,
.table-report.table-report--tabulator .tabulator-header .tabulator-headers .tabulator-col:nth-child(4) .tabulator-col-content .tabulator-col-title,
.table-report.table-report--tabulator .tabulator-header .tabulator-headers .tabulator-col:nth-child(5) .tabulator-col-content .tabulator-col-title,
.table-report.table-report--tabulator .tabulator-header .tabulator-headers .tabulator-col:nth-child(6) .tabulator-col-content .tabulator-col-title {
    text-align: left;
}

@media (max-width: 766px) {
    .payForm .payBt {
        padding-bottom: 2rem;
    }
}

@media(max-width: 1278px) {
    .payment .inner-wrap h2.title {
        line-height: 2rem;
    }
}

@media (max-width: 1340px) {
    .datepicker {
        width: calc(100% - 58px - 0.25rem);
        /* margin-bottom: 0.5rem; */
    }
}

@media (max-width: 766px) {
    .payment .inner-wrap h2.title {
        /* display: none; */
    }
}

/* 768px 이상 */
@media(min-width:768px) {
    .content {
        /* margin:7rem .75rem 0 0;  */
    }

    .content .tab-wrap {
        padding-top: 1.5rem;
    }

    .content .tab-wrap li a {
        font-size: .9375rem;
    }

    /* modal */
    .modal .modal-dialog {
        transform: translateY(-50%);
        margin: auto;
        padding: 1rem 2rem;
    }

    .show_modal .modal-dialog {
        top: 50%;
        transform: translateY(-50%);
    }
}

/* 1280px 이상 */
@media(min-width:1280px) {
    .content {
        /* height:calc(100vh - 9rem);  */
        /* padding: 0 2rem 1rem; */
    }

    .content .inner-wrap {
        display: block;
    }

    .content .tab-wrap {
        max-width: none;
        border: none;
    }

    .content .tab-wrap li:nth-child(1) {
        width: 40rem;
    }

    .content .tab-wrap li a {
        padding: 0;
        font-size: 1.0625rem;
        cursor: auto;
    }

    .content .tab-wrap li.current:before {
        opacity: 0;
    }

    .content .content-wrap {
        display: flex;
        max-width: none;
        /* justify-content: center; */
    }

    .content .intro-y {
        width: 100%;
        margin-left: 0;
        padding: 1rem;
        background: #fff;
    }

    /* payForm */
    .content-wrap .payForm {
        display: block;
        width: 30rem;
        flex-shrink: 0;
        box-shadow: 0 .25rem 1.25rem rgba(0, 0, 0, .04);
        overflow-y: hidden;
        background-color: #fff;
    }

    .intro-y {
        /* display: flex; */
        flex-wrap: wrap;
        top: 0;
    }

    .payForm .input {
        /* margin: 0 .75rem 1.375rem; */
    }

    /*.payForm .input:nth-child(-n+2), .payForm .input:nth-child(10) { width:calc(48% - 1.5rem); }*/
    /* .payForm .input:nth-child(3), .payForm .input:nth-child(n+7):nth-child(-n+8) { width:calc(50% - 1.5rem); } */
    .payForm .input:nth-child(-n+6) {
        width: 100%;
    }

    /* .payForm .input:nth-child(n+4):nth-child(-n+6), .payForm .input:nth-child(n+11):nth-child(-n+13) { width:calc(33.33% - 1.5rem); width: 100%;} */
    /* .payForm .input:nth-child(9) { width:calc(60% - 1.5rem); } */
    /* cardInfo */
    .content-wrap .cardInfo {
        display: block;
        width: calc(100% - 30rem);
        max-width: none;
        margin-left: 3rem;
        box-shadow: 0 .25rem 1.25rem rgba(0, 0, 0, .04);
    }

    .cardInfo .tabulator-header {
        border-top-width: .0625rem;
        border-bottom-width: .0625rem;
    }

    .cardInfo .tabulator-headers {}

    .cardInfo .tabulator-headers>div:nth-child(1) {
        display: inline-block;
    }

    .cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-content {
        margin: 0;
        text-align: left;
    }

    .cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-sorter {
        margin: 0;
    }

    .cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-title {
        font-size: 12px;
        font-weight: normal;
    }

    .cardInfo .tabulator-tableHolder .tabulator-table {
        width: auto;
        /* background: #fff; */
    }

    .cardInfo .tabulator-row,
    .cardInfo .tabulator-row.tabulator-row-even {
        margin: 0;
        /* background: none; */
        border-radius: 0;
        border-bottom-width: .0625rem;
    }

    .cardInfo .tabulator-row:nth-child(even) {
        background: #f1f5f9;
    }

    .cardInfo .tabulator-row .tabulator-cell {
        font-weight: normal;
    }

    .cardInfo .tabulator-tableHolder {
        /* height: calc(100% - 11rem) !important; */
        margin: 0;
    }

    .tabulator .tabulator-tableHolder .tabulator-placeholder {
        overflow-y: auto;
    }

    .tabulator .tabulator-footer {
        margin-top: 2rem;
    }

    /* font */
    /* .payment .inner-wrap h2.title {margin: 0 0.75rem 0;} */
}

@media (max-width: 768px) {
    .content .content-wrap {
        /* padding: 0.5rem 0 1rem; */
    }
}

@media (max-width: 1600px) {
    .cardInfo .tabulator-tableHolder {
        overflow: scroll auto;
    }
}

.big-input {
    font-size: 16px !important;
}

.form_filter .input_item .sorting {
    display: flex;
    margin-top: .375rem;
}

.form_filter .input_item .sorting.d_none {
    display: none;
}

.form_filter .input_item .sorting button {
    flex-grow: 1;
    height: 1.875rem;
    padding: 0;
    border-radius: 0;
    font-size: .7rem;
    letter-spacing: -.02rem;
    white-space: nowrap;
    padding: 0 7px;
}

.form_filter .input_item .sorting button+button {
    margin-left: -.0625rem;
}

.form_filter .input_item .sorting button:first-child {
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
}

.form_filter .input_item .sorting button:last-child {
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
}

.form_filter .input_item .sorting button:focus {
    --tw-ring-shadow: inset var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
}

@media(min-width:640px) {
    .form_filter .input_item .sorting {
        position: absolute;
        top: 0;
        right: 0;
        margin-top: -.25rem;
    }

    .form_filter .input_item .sorting.d_none {
        display: flex;
    }

    .form_filter .input_item .sorting button {
        height: 1.5rem;
        padding: 0 .625rem;
        font-size: .75rem;
    }

    .form_filter .input_item .sorting button+button {}

    .form_filter .input_item .sorting button:first-child {}

    .form_filter .input_item .sorting button:last-child {}

    .form_filter .input_item .sorting button:focus {}
}









/* 기본 */
.urlPayment-wrap {
    --text: #111;
    --muted: #6b7280;
    --line: #e5e7eb;
    --bg: #f3f5f7;
    --primary: #0b3a6f;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans KR", "Malgun Gothic", Pretendard, sans-serif;
    color: var(--text);
    background: var(--bg);
    max-width: 768px;
    margin: 0 auto;
    padding: 8px 12px 0;
}

/* 섹션/타이틀 */
.urlPayment-section {
    margin: 12px 0 20px;
}

.urlPayment-title {
    font-size: 16px;
    font-weight: bold;
    margin: 6px 4px 8px;
}

/* 카드 */
.urlPayment-card {
    border: 1px solid var(--line);
    border-radius: 14px;
    background: #fff;
    padding: 3px 12px;
    box-shadow: 0 1px 0 rgba(0, 0, 0, .02);
}

.urlPayment-card.card1 {
    padding: 10px 12px;
}

/* 폼 라인 */
.urlPayment-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 8px 0;
}

.urlPayment-label {
    width: 74px;
    color: var(--muted);
    font-weight: 700;
    font-size: 13px;
}

.urlPayment-input,
.urlPayment-select {
    flex: 1 1;
    border: 1px solid var(--line);
    border-radius: 6px;
    padding: 5px 10px;
    font-size: 14px;
    background: #fff;
    height: 35px;
}

.urlPayment-select {
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 16px 16px;
}

/* 주문상품 */
.urlPayment-orderHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.urlPayment-store {
    font-weight: 900;
    font-size: 14px;
}

.urlPayment-shipFee {
    color: #2563eb;
    font-weight: 800;
    font-size: 12px;
}

.urlPayment-orderBody {
    display: flex;
    gap: 10px;
}

.urlPayment-thumb {
    width: 60px;
    height: 60px;
    border-radius: 10px;
    background: #f1f3f5;
    flex: 0 0 60px;
    overflow: hidden;
}

.urlPayment-thumbImg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.urlPayment-info {
    flex: 1 1;
    min-width: 0;
}

.urlPayment-prod {
    font-weight: 500;
    font-size: 14px;
    line-height: 1.35;
    margin-bottom: 6px;
}

/* 옵션/수량 + 단가 줄 */
.urlPayment-itemBar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* background: #f6f7f9; */
    /* border-radius: 12px; */
    /* padding: 10px 12px; */
}

.urlPayment-itemLeft {
    color: #374151;
    font-size: 11px;
    font-weight: 700;
}

.urlPayment-itemRight {
    display: flex;
    align-items: center;
    gap: 8px;
}

.urlPayment-priceOld {
    color: #9ca3af;
    text-decoration: line-through;
    font-weight: 500;
    font-size: 12px;
}

.urlPayment-priceNow {
    font-weight: bold;
    font-size: 14px;
}

/* 카드 내부 총금액 줄 */
.urlPayment-totalInline {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 2px 0;
    font-size: 14px;
    margin-top: 10px;
    border-top: 1px solid #e5e7eb;
}

.urlPayment-totalLabel {
    color: #111;
    font-weight: bold;
}

.urlPayment-totalValue {
    font-weight: 900;
}

/* 하단 고정 버튼 */
.urlPayment-buybar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 50;
    /* background: #fff;
    border-top: 1px solid var(--line); */
    padding: 10px 12px calc(10px + env(safe-area-inset-bottom));
}

.urlPayment-buyBtn {
    width: 100%;
    border: none;
    border-radius: 12px;
    padding: 14px 10px;
    background: #0b3a6f;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
}

.urlPayment-buyBtn:disabled {
    background: #8a8d91;
    color: #d1d1d1;
    cursor: not-allowed;
    box-shadow: none;
}

/* 하단 버튼 공간 확보 */
.urlPayment-bottomPad {
    height: 72px;
}









/* ===== UrlUserHistory ===== */
.urlUserHistory-wrap {
    /* padding-bottom: 80px; */
    max-width: 768px;
    margin: 0 auto;
    padding: 8px 12px 0;
}

.urlUserHistory-section {
    margin: 12px auto 20px;
}

.urlUserHistory-title {
    font-size: 16px;
    font-weight: 700;
    margin: 8px 0 12px;
}

.urlUserHistory-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, .06);
    padding: 12px;
}

.urlUserHistory-successCard {
    background: #f4f8ff;
    border: 1px solid #e2ecff;
    border-radius: 12px;
    padding: 14px 12px;
}

.urlUserHistory-successTitle {
    font-weight: 700;
    margin-bottom: 4px;
}

.urlUserHistory-successMeta {
    color: #666;
    font-size: 13px;
}

.urlUserHistory-dot {
    margin: 0 6px 0 0;
    color: #aaa;
}

.urlUserHistory-row {
    display: grid;
    grid-template-columns: 92px 1fr;
    gap: 8px;
    padding: 4px 4px;
    align-items: start;
    /* border-bottom: 1px solid #f2f2f2; */
}

.urlUserHistory-row:last-child {
    border-bottom: 0;
}

.urlUserHistory-label {
    color: #666;
    font-size: 13px;
}

.urlUserHistory-value {
    font-size: 14px;
    word-break: break-word;
}

.urlUserHistory-orderHead {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 2px 10px;
    border-bottom: 1px solid #f2f2f2;
}

.urlUserHistory-store {
    font-weight: 700;
}

.urlUserHistory-shipFee {
    font-size: 12px;
    color: #2e7d32;
}

.urlUserHistory-orderBody {
    display: flex;
    gap: 12px;
    padding: 12px 2px 5px;
}

.urlUserHistory-thumb {
    flex: 0 0 68px;
}

.urlUserHistory-thumbImg {
    width: 68px;
    height: 68px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #eee;
}

.urlUserHistory-info {
    flex: 1 1;
    min-width: 0;
}

.urlUserHistory-prod {
    font-weight: 600;
    margin-bottom: 6px;
}

.urlUserHistory-itemBar {
    display: flex;
    justify-content: space-between;
    color: #666;
    font-size: 13px;
}

.urlUserHistory-itemLeft {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.urlUserHistory-itemRight {
    display: flex;
    align-items: center;
    gap: 8px;
}

.urlUserHistory-priceOld {
    text-decoration: line-through;
    color: #999;
}

.urlUserHistory-priceNow {
    font-weight: 700;
}

.urlUserHistory-priceBox {
    padding: 0px 2px 4px;
}

.urlUserHistory-priceRow {
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
    font-size: 14px;
}

.urlUserHistory-minus {
    color: #d32f2f;
}

.urlUserHistory-divider {
    height: 1px;
    background: #eee;
    margin: 6px 0;
}

.urlUserHistory-totalRow {
    font-size: 16px;
    font-weight: 800;
}

.urlUserHistory-bottomPad {
    height: 24px;
}

/* ===== Gate (이름/휴대폰 인증) ===== */
.urlUserHistory-gate {
    min-height: calc(100dvh - 3.5rem);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    background: #fff;
  }
  .urlUserHistory-gateCard {
    width: min(560px, 100%);
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,.08);
    padding: 20px 16px;
  }
  .urlUserHistory-gateTitle { font-size: 18px; font-weight: 800; margin-bottom: 12px; }
  .urlUserHistory-gateRow {
    display: grid;
    grid-template-columns: 84px 1fr;
    gap: 10px;
    align-items: center;
    margin: 10px 0;
  }
  .urlUserHistory-gateLabel { color:#666; font-size: 13px; }
  .urlUserHistory-gateInput {
    border: 1px solid #ddd; border-radius: 10px; padding: 12px; font-size: 15px;
    width: 100%; outline: none; background: #fff;
  }
  .urlUserHistory-gateInput:focus { border-color: #111; }
  .urlUserHistory-gateError { color: #d32f2f; font-size: 13px; margin-top: 6px; }
  .urlUserHistory-gateBtn {
    width: 100%; margin-top: 12px; padding: 12px 14px; border-radius: 10px;
    border: 1px solid #222; background: #111; color: #fff; font-weight: 700; cursor: pointer;
  }
  .urlUserHistory-gateBtn:disabled { opacity: .4; cursor: not-allowed; }

  /* 주문 상단 요약 카드: 날짜 + 주문번호 */
.urlUserHistory-orderHeader {
    background: #fff;
    border-radius: 12px;
    padding: 14px 16px;
    box-shadow: 0 1px 0 rgba(0,0,0,0.04);
  }
  
  .urlUserHistory-orderMeta {        /* 예: 2025.06.06. 20:12:16 */
    font-size: 12px;
    color: #6b7280;
    letter-spacing: 0.02em;
    margin-bottom: 6px;
  }
  
  .urlUserHistory-orderNo {          /* 예: 주문번호 2025060698702470 */
    font-size: 14px;
    font-weight: 600;
    color: #111827;
  }
  `, "",{"version":3,"sources":["webpack://./src/Pages/css/payment.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,iCAAiC;IACjC,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA,aAAa;AACb;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;;;GAGG;;AAEH;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iCAAiC;IACjC,4BAA4B;IAC5B,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;;AAGA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,wBAAwB;IACxB,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;;GAEG;AACH;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;;;;IAII,gBAAgB;AACpB;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kCAAkC;QAClC,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA,aAAa;AACb;IACI;QACI,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA,UAAU;IACV;QACI,2BAA2B;QAC3B,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,QAAQ;QACR,2BAA2B;IAC/B;AACJ;;AAEA,cAAc;AACd;IACI;QACI,gCAAgC;QAChC,0BAA0B;IAC9B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,oBAAoB;QACpB,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,cAAc;QACd,aAAa;QACb,gBAAgB;IACpB;;IAEA,YAAY;IACZ;QACI,cAAc;QACd,YAAY;QACZ,cAAc;QACd,+CAA+C;QAC/C,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;QACnB,eAAe;QACf,MAAM;IACV;;IAEA;QACI,+BAA+B;IACnC;;IAEA,+FAA+F;IAC/F,+GAA+G;IAC/G;QACI,WAAW;IACf;;IAEA,kJAAkJ;IAClJ,+DAA+D;IAC/D,aAAa;IACb;QACI,cAAc;QACd,yBAAyB;QACzB,eAAe;QACf,iBAAiB;QACjB,+CAA+C;IACnD;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA,8BAA8B;;IAE9B;QACI,qBAAqB;IACzB;;IAEA;QACI,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,sBAAsB;IAC1B;;IAEA;;QAEI,SAAS;QACT,sBAAsB;QACtB,gBAAgB;QAChB,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,2CAA2C;QAC3C,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA,SAAS;IACT,yDAAyD;AAC7D;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,+GAA+G;AACnH;;AAEA;IACI;QACI,kBAAkB;QAClB,MAAM;QACN,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA,iDAAiD;;IAEjD,sDAAsD;;IAEtD,qDAAqD;;IAErD,gDAAgD;AACpD;;;;;;;;;;AAUA,OAAO;AACP;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,2HAA2H;IAC3H,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,OAAO;AACP;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;AACtB;;AAEA,SAAS;AACT;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,SAAO;IACP,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,yDAA0O;IAC1O,4BAA4B;IAC5B,sCAAsC;IACtC,0BAA0B;AAC9B;;AAEA,SAAS;AACT;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,aAAa;AACb;IACI,eAAe;IACf,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX;wCACoC;IACpC,2DAA2D;AAC/D;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,YAAY;AAChB;;;;;;;;;;AAUA,+BAA+B;AAC/B;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA,iCAAiC;AACjC;IACI,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;IACtC,kBAAkB;EACpB;EACA,4BAA4B,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;EACpF;IACE,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,mBAAmB;IACnB,cAAc;EAChB;EACA,4BAA4B,UAAU,EAAE,eAAe,EAAE;EACzD;IACE,sBAAsB,EAAE,mBAAmB,EAAE,aAAa,EAAE,eAAe;IAC3E,WAAW,EAAE,aAAa,EAAE,gBAAgB;EAC9C;EACA,kCAAkC,kBAAkB,EAAE;EACtD,4BAA4B,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE;EAC9E;IACE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,mBAAmB;IACtE,sBAAsB,EAAE,gBAAgB,EAAE,WAAW,EAAE,gBAAgB,EAAE,eAAe;EAC1F;EACA,mCAAmC,WAAW,EAAE,mBAAmB,EAAE;;EAErE,2BAA2B;AAC7B;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;EACtC;;EAEA,mCAAmC,4BAA4B;IAC7D,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,mCAAmC,6BAA6B;IAC9D,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB","sourcesContent":[".scroll_lock {\r\n    overflow: hidden;\r\n}\r\n\r\n.content {\r\n    /* min-height:auto;  */\r\n    /* margin-top:4.5rem;  */\r\n    /* padding: 3.5rem 6% 1rem;  */\r\n    /* border-radius:1rem;  */\r\n}\r\n\r\n.content:before {\r\n    display: none;\r\n}\r\n\r\n.content .inner-wrap {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.content .tab-wrap {\r\n    position: relative;\r\n    width: 100%;\r\n    max-width: 33.75rem;\r\n    padding-top: .75rem;\r\n    border-bottom: .0625rem solid #d1d5d9;\r\n}\r\n\r\n.content .tab-wrap li {\r\n    display: inline-block;\r\n    position: relative;\r\n}\r\n\r\n.content .tab-wrap li:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: -.0625rem;\r\n    height: .1875rem;\r\n    background: #064e3b;\r\n    border-top-left-radius: .1875rem;\r\n    border-top-right-radius: .1875rem;\r\n    opacity: 0;\r\n}\r\n\r\n.content .tab-wrap li a {\r\n    display: block;\r\n    padding: 0 1rem;\r\n    font-size: .875rem;\r\n    font-weight: bold;\r\n    line-height: 3.25rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.content .tab-wrap li.current:before {\r\n    opacity: 1;\r\n}\r\n\r\n.content .content-wrap {\r\n    width: 100%;\r\n    max-width: 33.75rem;\r\n    margin: 0 auto;\r\n    /* padding: .5rem 0 1rem;  */\r\n}\r\n\r\n.content .intro-y {\r\n    /* display: flex; */\r\n    flex-wrap: wrap;\r\n    /* width:calc(100% + 1rem);  */\r\n    /* height:100%; */\r\n    /* margin-left: -.5rem; */\r\n    background: #fff;\r\n    padding: 10px;\r\n    box-shadow: none;\r\n    height: calc(-10rem + 100dvh);\r\n    overflow: scroll;\r\n}\r\n\r\n/* payForm */\r\n.content-wrap .payForm {\r\n    display: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.content-wrap .payForm.active {\r\n    display: block;\r\n}\r\n\r\n.payForm .form-label {\r\n    margin-bottom: .375rem;\r\n    font-size: .8125rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.payForm .input {\r\n    width: 100%;\r\n    /* margin: 0 .5rem 1rem; */\r\n    margin: 0 0 0.75rem;\r\n}\r\n\r\n.payForm .input.w33 {\r\n    width: calc(33.33% - 1rem);\r\n}\r\n\r\n.payForm .input.w50 {\r\n    width: calc(50% - 1rem);\r\n}\r\n\r\n.payForm .input.w66 {\r\n    width: calc(66.66% - 1rem);\r\n}\r\n\r\n.payForm .input .multiple {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.payForm .input .multiple span {\r\n    padding: 0 .375rem;\r\n}\r\n\r\n.payForm .mt-2,\r\n.payForm .mt-3 {\r\n    margin: 0;\r\n}\r\n\r\n.payForm .pos_aps_r {\r\n    margin: .25rem 0 -1.25rem;\r\n}\r\n\r\n.payForm .payBt {\r\n    width: 100%;\r\n    margin: 1rem 0;\r\n    text-align: center;\r\n}\r\n\r\n.payForm .payBt .btn {\r\n    width: 100%;\r\n    /* max-width: 12.5rem; */\r\n}\r\n\r\n/* cardInfo */\r\n.content-wrap .cardInfo {\r\n    display: none;\r\n    width: 100%;\r\n    max-width: 33.75rem;\r\n    margin: 0;\r\n    padding: 0;\r\n    overflow-y: auto;\r\n}\r\n\r\n.content-wrap .cardInfo.active {\r\n    display: block;\r\n}\r\n\r\n.cardInfo .tabulator {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.cardInfo .tabulator-header {\r\n    border-width: 0;\r\n}\r\n\r\n.cardInfo .tabulator-headers {\r\n    text-align: right;\r\n}\r\n\r\n.cardInfo .tabulator-headers>div:nth-child(1) {\r\n    display: none;\r\n}\r\n\r\n.cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-content {\r\n    margin-right: .5rem;\r\n    text-align: right;\r\n}\r\n\r\n.cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-sorter {\r\n    margin-right: -1.75rem;\r\n}\r\n\r\n.cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-title {\r\n    font-size: .9375rem;\r\n    font-weight: bold;\r\n}\r\n\r\n/* .cardInfo .tabulator-tableHolder {\r\n    margin-top: .5rem;\r\n    overflow: hidden;\r\n} */\r\n\r\n.tabulator .tabulator-tableHolder::-webkit-scrollbar {\r\n    -webkit-appearance: none;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder::-webkit-scrollbar:vertical {\r\n    display: block;\r\n    width: 1.125rem;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder::-webkit-scrollbar:horizontal {\r\n    display: block;\r\n    height: 1.125rem;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder::-webkit-scrollbar-thumb {\r\n    height: 15%;\r\n    border: .375rem solid transparent;\r\n    background-clip: content-box;\r\n    background-color: rgba(0, 0, 0, .25);\r\n    border-radius: 1.125rem;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder::-webkit-scrollbar-track {\r\n    background-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n\r\n.cardInfo .tabulator-tableHolder .tabulator-table {\r\n    width: 100%;\r\n    /* background: none; */\r\n}\r\n\r\n.cardInfo .tabulator-row,\r\n.cardInfo .tabulator-row.tabulator-row-even {\r\n    margin-bottom: 1.25rem;\r\n    background: #fff;\r\n    border-radius: .75rem;\r\n    border-bottom-width: 0;\r\n}\r\n\r\n.cardInfo .tabulator-row .tabulator-cell {\r\n    font-weight: bold;\r\n}\r\n\r\n.cardInfo .tabulator-row .tabulator-responsive-collapse table {\r\n    width: 100%;\r\n}\r\n\r\n.cardInfo .tabulator-row .tabulator-responsive-collapse td {\r\n    padding-top: .1875rem;\r\n    padding-bottom: .1875rem;\r\n    font-size: .8125rem;\r\n}\r\n\r\n.cardInfo .tabulator-row .tabulator-responsive-collapse td:nth-child(2) {\r\n    font-weight: bold;\r\n    text-align: right;\r\n}\r\n\r\n.cardInfo .tabulator-row .tabulator-responsive-collapse td strong {\r\n    color: #a1a5a9;\r\n}\r\n\r\n.cardInfo .tabulator-footer .tabulator-paginator {\r\n    justify-content: center;\r\n    text-align: center;\r\n}\r\n\r\ninput[type=\"number\"]::-webkit-outer-spin-button,\r\ninput[type=\"number\"]::-webkit-inner-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}\r\n\r\n.alert_modal .modal-footer {\r\n    border-color: transparent;\r\n}\r\n\r\n.payment {\r\n    height: 100%;\r\n}\r\n\r\n.payment .inner-wrap h2.title {\r\n    padding-bottom: 1rem;\r\n    /* margin: 0 0.5rem 0; */\r\n    font-size: 1.0625rem;\r\n    font-weight: bold;\r\n    line-height: 3.25rem;\r\n}\r\n\r\n.payment .inner-wrap>ul.title li:nth-child(1) {\r\n    width: 33rem;\r\n}\r\n\r\n.payment .inner-wrap>ul.title li:nth-child(2) {\r\n    width: calc(100% - 33rem);\r\n}\r\n\r\n.payment .cardInfo .tabulator-footer .tabulator-page.active {\r\n    background: #1a120b;\r\n    color: #fff;\r\n}\r\n\r\n.payment .cardInfo .tabulator-footer .tabulator-page.active:hover {\r\n    color: #fff;\r\n    background: #3D3C42;\r\n}\r\n\r\n/* .payment .intro-y {\r\n    height: calc(100vh - 12rem);\r\n} */\r\n@media (max-width: 766px) {\r\n    .payment {\r\n        height: auto;\r\n    }\r\n}\r\n\r\n.table-report.table-report--tabulator .tabulator-header .tabulator-headers .tabulator-col:nth-child(3) .tabulator-col-content .tabulator-col-title,\r\n.table-report.table-report--tabulator .tabulator-header .tabulator-headers .tabulator-col:nth-child(4) .tabulator-col-content .tabulator-col-title,\r\n.table-report.table-report--tabulator .tabulator-header .tabulator-headers .tabulator-col:nth-child(5) .tabulator-col-content .tabulator-col-title,\r\n.table-report.table-report--tabulator .tabulator-header .tabulator-headers .tabulator-col:nth-child(6) .tabulator-col-content .tabulator-col-title {\r\n    text-align: left;\r\n}\r\n\r\n@media (max-width: 766px) {\r\n    .payForm .payBt {\r\n        padding-bottom: 2rem;\r\n    }\r\n}\r\n\r\n@media(max-width: 1278px) {\r\n    .payment .inner-wrap h2.title {\r\n        line-height: 2rem;\r\n    }\r\n}\r\n\r\n@media (max-width: 1340px) {\r\n    .datepicker {\r\n        width: calc(100% - 58px - 0.25rem);\r\n        /* margin-bottom: 0.5rem; */\r\n    }\r\n}\r\n\r\n@media (max-width: 766px) {\r\n    .payment .inner-wrap h2.title {\r\n        /* display: none; */\r\n    }\r\n}\r\n\r\n/* 768px 이상 */\r\n@media(min-width:768px) {\r\n    .content {\r\n        /* margin:7rem .75rem 0 0;  */\r\n    }\r\n\r\n    .content .tab-wrap {\r\n        padding-top: 1.5rem;\r\n    }\r\n\r\n    .content .tab-wrap li a {\r\n        font-size: .9375rem;\r\n    }\r\n\r\n    /* modal */\r\n    .modal .modal-dialog {\r\n        transform: translateY(-50%);\r\n        margin: auto;\r\n        padding: 1rem 2rem;\r\n    }\r\n\r\n    .show_modal .modal-dialog {\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n    }\r\n}\r\n\r\n/* 1280px 이상 */\r\n@media(min-width:1280px) {\r\n    .content {\r\n        /* height:calc(100vh - 9rem);  */\r\n        /* padding: 0 2rem 1rem; */\r\n    }\r\n\r\n    .content .inner-wrap {\r\n        display: block;\r\n    }\r\n\r\n    .content .tab-wrap {\r\n        max-width: none;\r\n        border: none;\r\n    }\r\n\r\n    .content .tab-wrap li:nth-child(1) {\r\n        width: 40rem;\r\n    }\r\n\r\n    .content .tab-wrap li a {\r\n        padding: 0;\r\n        font-size: 1.0625rem;\r\n        cursor: auto;\r\n    }\r\n\r\n    .content .tab-wrap li.current:before {\r\n        opacity: 0;\r\n    }\r\n\r\n    .content .content-wrap {\r\n        display: flex;\r\n        max-width: none;\r\n        /* justify-content: center; */\r\n    }\r\n\r\n    .content .intro-y {\r\n        width: 100%;\r\n        margin-left: 0;\r\n        padding: 1rem;\r\n        background: #fff;\r\n    }\r\n\r\n    /* payForm */\r\n    .content-wrap .payForm {\r\n        display: block;\r\n        width: 30rem;\r\n        flex-shrink: 0;\r\n        box-shadow: 0 .25rem 1.25rem rgba(0, 0, 0, .04);\r\n        overflow-y: hidden;\r\n        background-color: #fff;\r\n    }\r\n\r\n    .intro-y {\r\n        /* display: flex; */\r\n        flex-wrap: wrap;\r\n        top: 0;\r\n    }\r\n\r\n    .payForm .input {\r\n        /* margin: 0 .75rem 1.375rem; */\r\n    }\r\n\r\n    /*.payForm .input:nth-child(-n+2), .payForm .input:nth-child(10) { width:calc(48% - 1.5rem); }*/\r\n    /* .payForm .input:nth-child(3), .payForm .input:nth-child(n+7):nth-child(-n+8) { width:calc(50% - 1.5rem); } */\r\n    .payForm .input:nth-child(-n+6) {\r\n        width: 100%;\r\n    }\r\n\r\n    /* .payForm .input:nth-child(n+4):nth-child(-n+6), .payForm .input:nth-child(n+11):nth-child(-n+13) { width:calc(33.33% - 1.5rem); width: 100%;} */\r\n    /* .payForm .input:nth-child(9) { width:calc(60% - 1.5rem); } */\r\n    /* cardInfo */\r\n    .content-wrap .cardInfo {\r\n        display: block;\r\n        width: calc(100% - 30rem);\r\n        max-width: none;\r\n        margin-left: 3rem;\r\n        box-shadow: 0 .25rem 1.25rem rgba(0, 0, 0, .04);\r\n    }\r\n\r\n    .cardInfo .tabulator-header {\r\n        border-top-width: .0625rem;\r\n        border-bottom-width: .0625rem;\r\n    }\r\n\r\n    .cardInfo .tabulator-headers {}\r\n\r\n    .cardInfo .tabulator-headers>div:nth-child(1) {\r\n        display: inline-block;\r\n    }\r\n\r\n    .cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-content {\r\n        margin: 0;\r\n        text-align: left;\r\n    }\r\n\r\n    .cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-sorter {\r\n        margin: 0;\r\n    }\r\n\r\n    .cardInfo .tabulator-headers>div:nth-child(2) .tabulator-col-title {\r\n        font-size: 12px;\r\n        font-weight: normal;\r\n    }\r\n\r\n    .cardInfo .tabulator-tableHolder .tabulator-table {\r\n        width: auto;\r\n        /* background: #fff; */\r\n    }\r\n\r\n    .cardInfo .tabulator-row,\r\n    .cardInfo .tabulator-row.tabulator-row-even {\r\n        margin: 0;\r\n        /* background: none; */\r\n        border-radius: 0;\r\n        border-bottom-width: .0625rem;\r\n    }\r\n\r\n    .cardInfo .tabulator-row:nth-child(even) {\r\n        background: #f1f5f9;\r\n    }\r\n\r\n    .cardInfo .tabulator-row .tabulator-cell {\r\n        font-weight: normal;\r\n    }\r\n\r\n    .cardInfo .tabulator-tableHolder {\r\n        /* height: calc(100% - 11rem) !important; */\r\n        margin: 0;\r\n    }\r\n\r\n    .tabulator .tabulator-tableHolder .tabulator-placeholder {\r\n        overflow-y: auto;\r\n    }\r\n\r\n    .tabulator .tabulator-footer {\r\n        margin-top: 2rem;\r\n    }\r\n\r\n    /* font */\r\n    /* .payment .inner-wrap h2.title {margin: 0 0.75rem 0;} */\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .content .content-wrap {\r\n        /* padding: 0.5rem 0 1rem; */\r\n    }\r\n}\r\n\r\n@media (max-width: 1600px) {\r\n    .cardInfo .tabulator-tableHolder {\r\n        overflow: scroll auto;\r\n    }\r\n}\r\n\r\n.big-input {\r\n    font-size: 16px !important;\r\n}\r\n\r\n.form_filter .input_item .sorting {\r\n    display: flex;\r\n    margin-top: .375rem;\r\n}\r\n\r\n.form_filter .input_item .sorting.d_none {\r\n    display: none;\r\n}\r\n\r\n.form_filter .input_item .sorting button {\r\n    flex-grow: 1;\r\n    height: 1.875rem;\r\n    padding: 0;\r\n    border-radius: 0;\r\n    font-size: .7rem;\r\n    letter-spacing: -.02rem;\r\n    white-space: nowrap;\r\n    padding: 0 7px;\r\n}\r\n\r\n.form_filter .input_item .sorting button+button {\r\n    margin-left: -.0625rem;\r\n}\r\n\r\n.form_filter .input_item .sorting button:first-child {\r\n    border-top-left-radius: .375rem;\r\n    border-bottom-left-radius: .375rem;\r\n}\r\n\r\n.form_filter .input_item .sorting button:last-child {\r\n    border-top-right-radius: .375rem;\r\n    border-bottom-right-radius: .375rem;\r\n}\r\n\r\n.form_filter .input_item .sorting button:focus {\r\n    --tw-ring-shadow: inset var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);\r\n}\r\n\r\n@media(min-width:640px) {\r\n    .form_filter .input_item .sorting {\r\n        position: absolute;\r\n        top: 0;\r\n        right: 0;\r\n        margin-top: -.25rem;\r\n    }\r\n\r\n    .form_filter .input_item .sorting.d_none {\r\n        display: flex;\r\n    }\r\n\r\n    .form_filter .input_item .sorting button {\r\n        height: 1.5rem;\r\n        padding: 0 .625rem;\r\n        font-size: .75rem;\r\n    }\r\n\r\n    .form_filter .input_item .sorting button+button {}\r\n\r\n    .form_filter .input_item .sorting button:first-child {}\r\n\r\n    .form_filter .input_item .sorting button:last-child {}\r\n\r\n    .form_filter .input_item .sorting button:focus {}\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* 기본 */\r\n.urlPayment-wrap {\r\n    --text: #111;\r\n    --muted: #6b7280;\r\n    --line: #e5e7eb;\r\n    --bg: #f3f5f7;\r\n    --primary: #0b3a6f;\r\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Noto Sans KR\", \"Malgun Gothic\", Pretendard, sans-serif;\r\n    color: var(--text);\r\n    background: var(--bg);\r\n    max-width: 768px;\r\n    margin: 0 auto;\r\n    padding: 8px 12px 0;\r\n}\r\n\r\n/* 섹션/타이틀 */\r\n.urlPayment-section {\r\n    margin: 12px 0 20px;\r\n}\r\n\r\n.urlPayment-title {\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    margin: 6px 4px 8px;\r\n}\r\n\r\n/* 카드 */\r\n.urlPayment-card {\r\n    border: 1px solid var(--line);\r\n    border-radius: 14px;\r\n    background: #fff;\r\n    padding: 3px 12px;\r\n    box-shadow: 0 1px 0 rgba(0, 0, 0, .02);\r\n}\r\n\r\n.urlPayment-card.card1 {\r\n    padding: 10px 12px;\r\n}\r\n\r\n/* 폼 라인 */\r\n.urlPayment-row {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    margin: 8px 0;\r\n}\r\n\r\n.urlPayment-label {\r\n    width: 74px;\r\n    color: var(--muted);\r\n    font-weight: 700;\r\n    font-size: 13px;\r\n}\r\n\r\n.urlPayment-input,\r\n.urlPayment-select {\r\n    flex: 1;\r\n    border: 1px solid var(--line);\r\n    border-radius: 6px;\r\n    padding: 5px 10px;\r\n    font-size: 14px;\r\n    background: #fff;\r\n    height: 35px;\r\n}\r\n\r\n.urlPayment-select {\r\n    appearance: none;\r\n    background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16'><path d='M4 6l4 4 4-4' stroke='%23999' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\");\r\n    background-repeat: no-repeat;\r\n    background-position: right 10px center;\r\n    background-size: 16px 16px;\r\n}\r\n\r\n/* 주문상품 */\r\n.urlPayment-orderHead {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.urlPayment-store {\r\n    font-weight: 900;\r\n    font-size: 14px;\r\n}\r\n\r\n.urlPayment-shipFee {\r\n    color: #2563eb;\r\n    font-weight: 800;\r\n    font-size: 12px;\r\n}\r\n\r\n.urlPayment-orderBody {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.urlPayment-thumb {\r\n    width: 60px;\r\n    height: 60px;\r\n    border-radius: 10px;\r\n    background: #f1f3f5;\r\n    flex: 0 0 60px;\r\n    overflow: hidden;\r\n}\r\n\r\n.urlPayment-thumbImg {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    display: block;\r\n}\r\n\r\n.urlPayment-info {\r\n    flex: 1;\r\n    min-width: 0;\r\n}\r\n\r\n.urlPayment-prod {\r\n    font-weight: 500;\r\n    font-size: 14px;\r\n    line-height: 1.35;\r\n    margin-bottom: 6px;\r\n}\r\n\r\n/* 옵션/수량 + 단가 줄 */\r\n.urlPayment-itemBar {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    /* background: #f6f7f9; */\r\n    /* border-radius: 12px; */\r\n    /* padding: 10px 12px; */\r\n}\r\n\r\n.urlPayment-itemLeft {\r\n    color: #374151;\r\n    font-size: 11px;\r\n    font-weight: 700;\r\n}\r\n\r\n.urlPayment-itemRight {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.urlPayment-priceOld {\r\n    color: #9ca3af;\r\n    text-decoration: line-through;\r\n    font-weight: 500;\r\n    font-size: 12px;\r\n}\r\n\r\n.urlPayment-priceNow {\r\n    font-weight: bold;\r\n    font-size: 14px;\r\n}\r\n\r\n/* 카드 내부 총금액 줄 */\r\n.urlPayment-totalInline {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 10px 2px 0;\r\n    font-size: 14px;\r\n    margin-top: 10px;\r\n    border-top: 1px solid #e5e7eb;\r\n}\r\n\r\n.urlPayment-totalLabel {\r\n    color: #111;\r\n    font-weight: bold;\r\n}\r\n\r\n.urlPayment-totalValue {\r\n    font-weight: 900;\r\n}\r\n\r\n/* 하단 고정 버튼 */\r\n.urlPayment-buybar {\r\n    position: fixed;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    z-index: 50;\r\n    /* background: #fff;\r\n    border-top: 1px solid var(--line); */\r\n    padding: 10px 12px calc(10px + env(safe-area-inset-bottom));\r\n}\r\n\r\n.urlPayment-buyBtn {\r\n    width: 100%;\r\n    border: none;\r\n    border-radius: 12px;\r\n    padding: 14px 10px;\r\n    background: #0b3a6f;\r\n    color: #fff;\r\n    font-weight: bold;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n}\r\n\r\n.urlPayment-buyBtn:disabled {\r\n    background: #8a8d91;\r\n    color: #d1d1d1;\r\n    cursor: not-allowed;\r\n    box-shadow: none;\r\n}\r\n\r\n/* 하단 버튼 공간 확보 */\r\n.urlPayment-bottomPad {\r\n    height: 72px;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* ===== UrlUserHistory ===== */\r\n.urlUserHistory-wrap {\r\n    /* padding-bottom: 80px; */\r\n    max-width: 768px;\r\n    margin: 0 auto;\r\n    padding: 8px 12px 0;\r\n}\r\n\r\n.urlUserHistory-section {\r\n    margin: 12px auto 20px;\r\n}\r\n\r\n.urlUserHistory-title {\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n    margin: 8px 0 12px;\r\n}\r\n\r\n.urlUserHistory-card {\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, .06);\r\n    padding: 12px;\r\n}\r\n\r\n.urlUserHistory-successCard {\r\n    background: #f4f8ff;\r\n    border: 1px solid #e2ecff;\r\n    border-radius: 12px;\r\n    padding: 14px 12px;\r\n}\r\n\r\n.urlUserHistory-successTitle {\r\n    font-weight: 700;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.urlUserHistory-successMeta {\r\n    color: #666;\r\n    font-size: 13px;\r\n}\r\n\r\n.urlUserHistory-dot {\r\n    margin: 0 6px 0 0;\r\n    color: #aaa;\r\n}\r\n\r\n.urlUserHistory-row {\r\n    display: grid;\r\n    grid-template-columns: 92px 1fr;\r\n    gap: 8px;\r\n    padding: 4px 4px;\r\n    align-items: start;\r\n    /* border-bottom: 1px solid #f2f2f2; */\r\n}\r\n\r\n.urlUserHistory-row:last-child {\r\n    border-bottom: 0;\r\n}\r\n\r\n.urlUserHistory-label {\r\n    color: #666;\r\n    font-size: 13px;\r\n}\r\n\r\n.urlUserHistory-value {\r\n    font-size: 14px;\r\n    word-break: break-word;\r\n}\r\n\r\n.urlUserHistory-orderHead {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 4px 2px 10px;\r\n    border-bottom: 1px solid #f2f2f2;\r\n}\r\n\r\n.urlUserHistory-store {\r\n    font-weight: 700;\r\n}\r\n\r\n.urlUserHistory-shipFee {\r\n    font-size: 12px;\r\n    color: #2e7d32;\r\n}\r\n\r\n.urlUserHistory-orderBody {\r\n    display: flex;\r\n    gap: 12px;\r\n    padding: 12px 2px 5px;\r\n}\r\n\r\n.urlUserHistory-thumb {\r\n    flex: 0 0 68px;\r\n}\r\n\r\n.urlUserHistory-thumbImg {\r\n    width: 68px;\r\n    height: 68px;\r\n    object-fit: cover;\r\n    border-radius: 8px;\r\n    border: 1px solid #eee;\r\n}\r\n\r\n.urlUserHistory-info {\r\n    flex: 1;\r\n    min-width: 0;\r\n}\r\n\r\n.urlUserHistory-prod {\r\n    font-weight: 600;\r\n    margin-bottom: 6px;\r\n}\r\n\r\n.urlUserHistory-itemBar {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    color: #666;\r\n    font-size: 13px;\r\n}\r\n\r\n.urlUserHistory-itemLeft {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.urlUserHistory-itemRight {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.urlUserHistory-priceOld {\r\n    text-decoration: line-through;\r\n    color: #999;\r\n}\r\n\r\n.urlUserHistory-priceNow {\r\n    font-weight: 700;\r\n}\r\n\r\n.urlUserHistory-priceBox {\r\n    padding: 0px 2px 4px;\r\n}\r\n\r\n.urlUserHistory-priceRow {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 6px 0;\r\n    font-size: 14px;\r\n}\r\n\r\n.urlUserHistory-minus {\r\n    color: #d32f2f;\r\n}\r\n\r\n.urlUserHistory-divider {\r\n    height: 1px;\r\n    background: #eee;\r\n    margin: 6px 0;\r\n}\r\n\r\n.urlUserHistory-totalRow {\r\n    font-size: 16px;\r\n    font-weight: 800;\r\n}\r\n\r\n.urlUserHistory-bottomPad {\r\n    height: 24px;\r\n}\r\n\r\n/* ===== Gate (이름/휴대폰 인증) ===== */\r\n.urlUserHistory-gate {\r\n    min-height: calc(100dvh - 3.5rem);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 16px;\r\n    background: #fff;\r\n  }\r\n  .urlUserHistory-gateCard {\r\n    width: min(560px, 100%);\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    box-shadow: 0 2px 12px rgba(0,0,0,.08);\r\n    padding: 20px 16px;\r\n  }\r\n  .urlUserHistory-gateTitle { font-size: 18px; font-weight: 800; margin-bottom: 12px; }\r\n  .urlUserHistory-gateRow {\r\n    display: grid;\r\n    grid-template-columns: 84px 1fr;\r\n    gap: 10px;\r\n    align-items: center;\r\n    margin: 10px 0;\r\n  }\r\n  .urlUserHistory-gateLabel { color:#666; font-size: 13px; }\r\n  .urlUserHistory-gateInput {\r\n    border: 1px solid #ddd; border-radius: 10px; padding: 12px; font-size: 15px;\r\n    width: 100%; outline: none; background: #fff;\r\n  }\r\n  .urlUserHistory-gateInput:focus { border-color: #111; }\r\n  .urlUserHistory-gateError { color: #d32f2f; font-size: 13px; margin-top: 6px; }\r\n  .urlUserHistory-gateBtn {\r\n    width: 100%; margin-top: 12px; padding: 12px 14px; border-radius: 10px;\r\n    border: 1px solid #222; background: #111; color: #fff; font-weight: 700; cursor: pointer;\r\n  }\r\n  .urlUserHistory-gateBtn:disabled { opacity: .4; cursor: not-allowed; }\r\n\r\n  /* 주문 상단 요약 카드: 날짜 + 주문번호 */\r\n.urlUserHistory-orderHeader {\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    padding: 14px 16px;\r\n    box-shadow: 0 1px 0 rgba(0,0,0,0.04);\r\n  }\r\n  \r\n  .urlUserHistory-orderMeta {        /* 예: 2025.06.06. 20:12:16 */\r\n    font-size: 12px;\r\n    color: #6b7280;\r\n    letter-spacing: 0.02em;\r\n    margin-bottom: 6px;\r\n  }\r\n  \r\n  .urlUserHistory-orderNo {          /* 예: 주문번호 2025060698702470 */\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: #111827;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
